"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSetting = void 0;
const class_transformer_1 = require("class-transformer");
class NetworkSetting {
    targetGoogleSearch = true;
    targetSearchNetwork = true;
    targetContentNetwork = true;
    targetPartnerSearchNetwork = true;
}
exports.NetworkSetting = NetworkSetting;
__decorate([
    (0, class_transformer_1.Expose)()
    // Ads will be served with Google.com search results
    ,
    __metadata("design:type", Boolean)
], NetworkSetting.prototype, "targetGoogleSearch", void 0);
__decorate([
    (0, class_transformer_1.Expose)()
    // Ads will be served on partner sites in the Google Search Network (requires GOOGLE_SEARCH).
    ,
    __metadata("design:type", Boolean)
], NetworkSetting.prototype, "targetSearchNetwork", void 0);
__decorate([
    (0, class_transformer_1.Expose)()
    // Ads will be served on specified placements in the Google Display Network
    ,
    __metadata("design:type", Boolean)
], NetworkSetting.prototype, "targetContentNetwork", void 0);
__decorate([
    (0, class_transformer_1.Expose)()
    // Ads will be served on the Google Partner Network. This is available to only some specific Google partner accounts.
    ,
    __metadata("design:type", Boolean)
], NetworkSetting.prototype, "targetPartnerSearchNetwork", void 0);
//# sourceMappingURL=NetworkSetting.js.map